import { CATEGORIES_FOR_SEO } from "constants/navigation/categories";
import { GameType } from "types/Games";

export const getTitle = (
  title: string | undefined,
  geo: string | null,
  category: string,
  game: string,
  providers: string | null,
  currentGame: GameType | null,
) => {
  const defaultTitle =
    import.meta.env.VITE_APP_PROJECT_NAME === "banger"
      ? "Banger Сasino | Real Money Casino Games | Best Online Slot"
      : "Glory Сasino | Real Money Casino Games | Best Online Slot";
  const casinoName =
    import.meta.env.VITE_APP_PROJECT_NAME === "banger"
      ? "Banger Casino | "
      : "Glory Casino | ";

  if (providers && providers.length) {
    return `${casinoName}👇 ${providers} ♣ Play Slots at ${geo}`;
  }

  // if (category && !game) {
  //   return `${casinoName}👇 ${CATEGORIES_FOR_SEO[category]} ♣ Play and Win in ${import.meta.env.VITE_APP_PROJECT_NAME === "banger" ? "Banger" : "Glory"}`;
  // }

  if (category && currentGame) {
    return `${casinoName}👇 ${CATEGORIES_FOR_SEO[category]} ${currentGame.name} ♣ Play and Win in ${import.meta.env.VITE_APP_PROJECT_NAME === "banger" ? "Banger" : "Glory"}`;
  }

  return title || defaultTitle;
};
